export default {
    namespaced: true,
    state: {
        data: null
    },
    getters: {
        data(state) {
            return state.data;
        },
    },
    mutations: {
        catchFish(state, data) {
            
        },
        setValue(state, data) {
            state[data[0]] = data[1];
        }
    },
    actions: {
        catchFish({ commit }, data) {
            return new Promise((approve, reject) => {
                commit('catchFish', data);
                this.getters.socket.emit("fish/catch", data, (result) => {
                    approve(result);
                });
            });

            
        },
        setValue({ commit }, data) {
            commit('setValue', data)
        },
    }
};